import { Button } from '@/components/ui/button';
import {
    Sheet,
    SheetClose,
    SheetContent,
    SheetDescription,
    SheetTrigger,
} from '@/components/ui/sheet';
import { FilterIcon } from 'lucide-react';
import React from 'react';

export default function MenuRadio({ children }: { children: React.ReactNode }) {
    return (
        <Sheet>
            <SheetTrigger asChild className="sticky top-0 left-0 ">
                <Button variant="default" className="bg-blue w-max !p-3 !h-[44px] text-white">
                    <div className="items-center flex justify-center gap-2 w-full"> 
                        <FilterIcon className="size-5 md:size-6" />
                    </div>
                </Button>
            </SheetTrigger>
            <SheetContent
                side={'bottom'}
                className="-top-1 !bg-white !px-2.5 overflow-y-scroll right-0 w-full h-full"
            >
                <div className="gap-3 flex flex-col justify-between items-center shadow-md p-3 rounded-xl w-full text-center duration-150">
                    <p className="text-justify text-sm">
                        با ارسال درخواست خود برای همه مراکز تصویربرداری امکان
                        پذیرش توسط چند مرکز مختلف قابل اجرا بوده و شما می توانید
                        گزینه پذیرش مورد نظر خود را انتخاب کنید.
                    </p>
                </div>
                <SheetDescription>
                    <SheetDescription>{children}</SheetDescription>
                    <SheetClose asChild>
                        <Button className="mt-3 !h-10 !text-base bg-blue w-full rounded-2xl text-white" size={'sm'}>
                            ذخیره
                        </Button>
                    </SheetClose>
                </SheetDescription>
            </SheetContent>
        </Sheet>
    );
}
